<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7163 16.6654H8.5188C5.2893 16.6654 3.67454 16.6654 2.67125 15.689C1.66797 14.7128 1.66797 13.1414 1.66797 9.9987C1.66797 6.856 1.66797 5.28466 2.67125 4.30834C3.67454 3.33203 5.28931 3.33203 8.5188 3.33203H10.7163C12.5725 3.33203 13.5006 3.33203 14.2754 3.74989C15.0501 4.16775 15.542 4.93362 16.5258 6.46537L17.0931 7.34871C17.9208 8.63736 18.3346 9.2817 18.3346 9.9987C18.3346 10.7157 17.9208 11.36 17.0931 12.6487L16.5258 13.532C15.542 15.0638 15.0501 15.8296 14.2754 16.2475C13.5006 16.6654 12.5725 16.6654 10.7163 16.6654ZM5.83463 5.87722C6.17981 5.87722 6.45963 6.14058 6.45963 6.46546V13.5281C6.45963 13.8529 6.17981 14.1164 5.83463 14.1164C5.48946 14.1164 5.20963 13.8529 5.20963 13.5281V6.46546C5.20963 6.14058 5.48946 5.87722 5.83463 5.87722Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TaxServicesIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>